import { Box, HStack, Flex, useColorModeValue, IconButton } from '@chakra-ui/react'
import {LogoIconContactCenterHeader} from 'icons/header-logo'
import React, { memo } from 'react'
import { useContactCenterModalEvents } from './contact-center.hooks'
import { useDialerState } from './dialer/dialer.hooks'

interface IContactCenterModalHeader {}

const ContactCenterModalHeader: React.FC<IContactCenterModalHeader> = () => {
  const { dialerState } = useDialerState()

  const { hide: hideContactCenter, close: closeContactCenter } = useContactCenterModalEvents()

  const handleClose = () => {
    dialerState.TwilioCallConnection?.disconnect()
    dialerState.TwilioDevice?.disconnectAll()
    closeContactCenter()
  }
  return (
    <Box py="8px" pl={{ base: '1', md: '3' }} bg={useColorModeValue('#E5F2FA', 'black')} w="100%">
      <HStack justifyContent="space-between">
        <Flex>
          <Box display={{ base: 'none', sm: 'inline' }}>
            <LogoIconContactCenterHeader />
          </Box>
        </Flex>
        <Flex>
          <Box display={{ base: 'none', sm: 'inline' }} mr="25px">
            <MinimiseButton onClick={hideContactCenter} />
          </Box>
          <Box display={{ base: 'none', sm: 'inline' }} mr="25px">
            <CloseButton onClick={handleClose} />
          </Box>
        </Flex>
      </HStack>
    </Box>
  )
}

const MinimiseButton: React.FC<{ onClick: () => void }> = memo(({ onClick }) => {
  return (
    <IconButton aria-label="Minimise contact center" size="sm" variant="unstyled" minWidth="20px" onClick={onClick}>
      <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.875 12.5C6.79303 12.501 6.71176 12.4848 6.63641 12.4525C6.56106 12.4202 6.49331 12.3725 6.4375 12.3125C6.1875 12.0625 6.1875 11.675 6.4375 11.425L14.5625 3.3125C14.8125 3.0625 15.2 3.0625 15.45 3.3125C15.7 3.5625 15.7 3.95 15.45 4.2L7.325 12.325C7.2 12.45 7.0375 12.5125 6.8875 12.5125L6.875 12.5Z"
          fill="#345EA6"
        />
        <path
          d="M11.875 12.5H6.875C6.525 12.5 6.25 12.225 6.25 11.875V6.875C6.25 6.525 6.525 6.25 6.875 6.25C7.225 6.25 7.5 6.525 7.5 6.875V11.25H11.875C12.225 11.25 12.5 11.525 12.5 11.875C12.5 12.225 12.225 12.5 11.875 12.5Z"
          fill="#345EA6"
        />
        <path
          d="M14.375 17.5H3.125C2.0875 17.5 1.25 16.6625 1.25 15.625V4.375C1.25 3.3375 2.0875 2.5 3.125 2.5H9.375C9.725 2.5 10 2.775 10 3.125C10 3.475 9.725 3.75 9.375 3.75H3.125C2.775 3.75 2.5 4.025 2.5 4.375V15.625C2.5 15.975 2.775 16.25 3.125 16.25H14.375C14.725 16.25 15 15.975 15 15.625V9.375C15 9.025 15.275 8.75 15.625 8.75C15.975 8.75 16.25 9.025 16.25 9.375V15.625C16.25 16.6625 15.4125 17.5 14.375 17.5Z"
          fill="#345EA6"
        />
      </svg>
    </IconButton>
  )
})

const CloseButton: React.FC<{ onClick: () => void }> = memo(({ onClick }) => {
  return (
    <IconButton aria-label="close contact center" size="sm" variant="unstyled" minWidth="20px" onClick={onClick}>
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.54088 4.66688L9.85065 0L11.0818 1.33312L6.77199 6L11.0818 10.6669L9.85065 12L5.54088 7.33312L1.23111 12L0 10.6669L4.30977 6L0 1.33312L1.23111 0L5.54088 4.66688Z" fill="#416AAD"/>
</svg>

    </IconButton>
  )
})

export default memo(ContactCenterModalHeader)
